import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("os_token")) {
      setReady(true);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("os_token")).finally(() => setReady(true));
  }, []);

  const signIn = (data) => {
    localStorage.setItem("os_token", data.token);
    setUser(data.user);
  };
  const signOut = () => {
    localStorage.removeItem("os_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, ready, signIn, signOut, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
